import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-annule-ticket-caisse',
  templateUrl: './annule-ticket-caisse.component.html',
  styleUrls: ['./annule-ticket-caisse.component.scss']
})
export class AnnuleTicketCaisseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
